import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PhotoSource } from '@fc-vehicles/components/dialogs/vehicle-photo-upload-dialog/uploaded-list/photo.source';
import { VehicleAttachmentModel } from '@fc-vehicles/models/vehicle-attachment-model';

@Injectable({
  providedIn: 'root',
})
export class PhotoUploadService {
  constructor(private http: HttpClient) {}

  uploadPhoto(
    sources: PhotoSource[],
    vehicleId: number,
  ): Observable<VehicleAttachmentModel[]> {
    const photoRequests = sources.map((source) => {
      const formData = new FormData();
      formData.append('original', source.source);
      formData.append('description', source.description);
      formData.append('isPrimary', source.isPrimary.toString());
      formData.append('vehicle', vehicleId.toString());
      return this.http.post<VehicleAttachmentModel>(
        `${environment.apiUrl}api/files/vehicles/${vehicleId}/photos/`,
        formData,
      );
    });

    return forkJoin(...photoRequests);
  }

  getVehiclePhotos(vehicleId: number): Observable<VehicleAttachmentModel[]> {
    return this.http.get<VehicleAttachmentModel[]>(
      `${environment.apiUrl}api/files/vehicles/${vehicleId}/photos/`,
    );
  }

  deleteVehiclePhoto(vehiclePhoto: VehicleAttachmentModel): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiUrl}api/files/vehicles/${vehiclePhoto.vehicle}/photos/${vehiclePhoto.id}/`,
    );
  }

  deleteVehiclePhotos(photos: VehicleAttachmentModel[]): Observable<void[]> {
    const requests = photos.map((photo) => this.deleteVehiclePhoto(photo));
    return forkJoin(requests);
  }

  updateVehiclePhoto(
    fields: { [key: string]: any },
    photoId: number,
    vehicleId: number,
  ): Observable<VehicleAttachmentModel> {
    return this.http.patch<VehicleAttachmentModel>(
      `${environment.apiUrl}api/files/vehicles/${vehicleId}/photos/${photoId}/`,
      fields,
    );
  }
}
